var gameName = $('.app__initial-state').data('game')

export var pokerEnv = $('.app__initial-state').data('env') // dev, qa, tq, centum, review, rdy, live

/** 제휴 포인트 활성화 : 현재는 개발 환경 일부만 */
export var isPointEnabled = ['dev', 'qa', 'tq', 'rdy'].includes(pokerEnv)

/**
 * @typedef {"none"|"silverclass"|"goldclass"} MembershipName
 * @typedef {"골드클래스" | "실버클래스"} ClassName
 * @type {MembershipName | ClassName}
 */
var pokerClassName = $('.app__initial-state').data('membership')

export var GOODS_ID = {
  /** 정기권 골드, 실버, 부스터 */
  AUTO: [500003, 500002, 626452],

  /** 개월권 골드, 실버, 부스터 */
  MONTHLY: [500005, 500004, 626453],

  /** 모듬세트, 실속세트(2023년 5월) : 즉시 구매와 / 무통장 | 실시간 계좌 이체만 가능, 구매전 동의 표시 */
  GOODS_PACKAGE: [80005, 80012, 80018],

  /** 바로 결제만 가능. 2022년 9월에 강제퇴장권 추가 */
  PAYNOW_ONLY: [4010],

  /** 행운 카드 뽑기 */
  LUCKY_DRAW: [210022],

  /** VIP 쿠폰 사용 불가 상품 (행운뽑기, 아바타 뽑기) */
  VIP_COUPON_EXCLUDED: [210022, 5000001],

  /** 사다리 타기 */
  LADDER_GAME: [210029],

  /** 구매 완료 후 아이템함 가기 버튼 숨기기 */
  HIDE_ITEM_BOX: [210029],

  /** 한번에 하나만 구매 가능한 상품 */
  ONE_BY_ONE: [210029],

  /** 구매시 선물함으로 가는 상품. 2024년 3월. 이모티콘 뽑기 추가 */
  GIFT_BOX: [2200011],

  /** 제휴 포인트 연동 상품 */
  POINT_GOODS: [2200011],
}

/** 제휴 포인트 활성화시 이모티콘 뽑기는 바로결제만 가능 */
if (isPointEnabled) {
  GOODS_ID.PAYNOW_ONLY.push(2200011)
}

/** 게임홈에서 포커몰이 열렸는지 여부, 게임홈 우측 영역의 DOM이 존재하는지 확인 */
export var isOpenedWeb = $('.app__user-info,.membership-root').length > 0

/** PC클라이언트 안에서 포커몰이 열렸는지 여부  */
export var isOpenedGame = !isOpenedWeb

export var isDev = NODE_ENV !== 'production'

// eslint-disable-next-line no-undef
var isLocal = Boolean(LOCAL_ENV) // 환경변수 설정 필요

var apiPrefix = isLocal ? 'https://poker-local.pmang.com/api/' : '/api/'

export var API_ENDPOINT = apiPrefix + gameName + '/mall'

export var BOUNS_PRICE = [55000, 99000]

export var BOUNS_REWARD = {
  55000: {
    rewrad: 27500000000000,
    bouns: 550000000000,
  },
  99000: {
    rewrad: 49500000000000,
    bouns: 2000000000000,
  },
}
/**
 * 단독 실행시 파라미터로 주입 | 아니면 list 호출 할때 주입
 */
export var TRACKING_CODE = ''

export var STATUS = {
  unauthorized: 401,
  conflict: 409,
}

export var API_PATH = {
  VALITDATE_GOODS: '/validate/goods',
  VALITDATE_GIFT: '/validate/gift',
  VALITDATE_HOTDEAL: '/validate/hotdeal',
  VALITDATE_AUTO: '/validate/auto',
  VALITDATE_FRIEND_GSN: '/validate/friendgsn',
  VALITDATE_FRIEND_ID: '/validate/friendid',
  BUY_PMANGCASH: '/buy/pmangcash',
  BUY_PMANGCASH_CHARGE: '/buy/charge',
  BUY_GIFT: '/buy/giftpmangcash',
  BUY_GIFT_CHARGE: '/buy/giftcharge',
  /** 제휴 포인트 */
  CONNECT_POINT: '/connect-point',
  DISCONNECT_POINT: '/disconnect-point',
}

export var LINK = {
  HELP: '//help.pmang.com/main/mainPage.do',
  MY_CLASS_INFO: '//poker.pmang.com/7poker/membership',
  POLICY: '//www.pmang.com/pmang_policy.nwz?tab=2',
}

export var REFUND_INFO =
  '<i>※</i> 복수 구매 시 합산 유효기간은 최대 100일입니다.<br /><i>※</i> 청약철회는 구매일로부터 7일 이내에 가능합니다. (단, 사용했을 경우 청약철회 불가)  <a href="' +
  LINK.POLICY +
  '" target="_blank">[자세히 보기]</a>'

export var REFUND_INFO_MONTHLY =
  '<i>※</i> 청약철회는 구매일로부터 7일 이내에 가능합니다. (단, 사용했을 경우 청약철회 불가)  <a href="' +
  LINK.POLICY +
  '" target="_blank">[자세히 보기]</a>'

export function moveGameScene(sceneName) {
  return 'npsusl://onWebViewClose?reload=' + String(sceneName)
}

export function getPokerClass() {
  return pokerClassName
}

/** @param {MembershipName | ClassName} newClassName */
export function setPokerClass(newClassName) {
  pokerClassName = newClassName
}

export function setTrackingCode(t) {
  TRACKING_CODE = t
}

export function checkIsGoldClass() {
  return getPokerClass() === '골드클래스' || getPokerClass() === 'goldclass'
}

export function getPointLoginUrl() {
  if (pokerEnv === 'rdy' || pokerEnv === 'live') {
    return 'https://login.milesoftuniverse.com'
  } else {
    return 'https://login.dev.milesoftuniverse.com'
  }
}
